import { Override, RadioGroup, RadioGroupProps, RadioLabelValue, RadioValue } from "best-common-react";
import React from "react";

type YesNoRadioInputProps = Override<
  RadioGroupProps,
  {
    value?: boolean;
    onChange: (value: boolean) => void;
    options?: RadioLabelValue[];
  }
>;

const YesNoRadioInput: React.FC<YesNoRadioInputProps> = ({ value = false, onChange, options = [], ...rest }) => {
  const yesNoOptions: RadioLabelValue[] = [
    {
      value: "yes",
      label: "Yes",
    },
    {
      value: "no",
      label: "No",
    },
  ];
  const finalOptions = options.length === 0 ? yesNoOptions : options;

  return (
    <RadioGroup
      {...rest}
      value={value ? finalOptions[0].value : finalOptions[1].value}
      options={finalOptions}
      onChange={(value: RadioValue | undefined) => {
        const result: boolean = value === finalOptions[0].value;
        onChange(result);
      }}
    />
  );
};

export default YesNoRadioInput;
